module.exports = __webpack_public_path__ + "static/media/badgeOff_326.cdd81c6a.png";